import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { VerifyEmailPage } from './pages/VerifyEmailPage';
import { WebsitesListPage } from './pages/WebsitesListPage';
import { WebsiteDetailPage } from './pages/WebsiteDetailPage';
import { BillingPage } from './pages/BillingPage';
import { InboxPage } from './pages/InboxPage';
import { SettingsHandoffPage } from './pages/SettingsHandoffPage';
import { SettingsTelegramPage } from './pages/SettingsTelegramPage';
import { SettingsAccountPage } from './pages/SettingsAccountPage';
import { TeamPage } from './pages/TeamPage';
import { useAuth } from './auth/AuthContext';

function OwnerOnly({ children }: { children: JSX.Element }) {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role !== 'owner') return <Navigate to="/inbox" replace />;
  return children;
}

function HomeRedirect() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === 'agent') return <Navigate to="/inbox" replace />;
  return <Navigate to="/websites" replace />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<HomeRedirect />} />
        <Route path="/inbox" element={<InboxPage />} />
        <Route
          path="/websites"
          element={
            <OwnerOnly>
              <WebsitesListPage />
            </OwnerOnly>
          }
        />
        <Route
          path="/websites/:id"
          element={
            <OwnerOnly>
              <WebsiteDetailPage />
            </OwnerOnly>
          }
        />
        <Route
          path="/team"
          element={
            <OwnerOnly>
              <TeamPage />
            </OwnerOnly>
          }
        />
        <Route
          path="/billing"
          element={
            <OwnerOnly>
              <BillingPage />
            </OwnerOnly>
          }
        />
        <Route
          path="/settings/handoff"
          element={
            <OwnerOnly>
              <SettingsHandoffPage />
            </OwnerOnly>
          }
        />
        {/* Telegram linking is per-agent, so any team member can land here. */}
        <Route path="/settings/telegram" element={<SettingsTelegramPage />} />
        <Route path="/settings/account" element={<SettingsAccountPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
